<template>
  <BriefStep :title="title">
    <template v-slot:content>
      <div class="brief-form">
        <div
          class="
            form__input-wrapper
            form__input-wrapper--check
            form__input-wrapper--check-squer
          "
          v-for="radio in formRadios"
          :key="radio.name"
        >
          <input
            class=""
            :id="radio.name"
            type="checkbox"
            :name="radio.name"
            :value="radio.value"
            v-model.trim="form.whatNeed"
            @input="invokeTouch($v.form.whatNeed)"
          />
          <label :for="radio.name" class="form__label">{{ radio.label }}</label>
        </div>
        <div
          class="
            form__input-wrapper
            form__input-wrapper--check
            form__input-wrapper--check-squer
          "
        >
          <input
            class=""
            id="other"
            type="checkbox"
            name="whatNeed"
            value=""
            v-model.trim="form.whatNeed"
            @input="invokeTouch($v.form.whatNeed)"
            @click="otherHandler"
          />
          <label for="other" class="form__label">Inne</label>
        </div>
        <transition name="fade-input">
          <div
            v-if="hasDescription"
            class="form__input-wrapper"
            :class="{ error: $v.form.whatNeedDetails.$anyError }"
          >
            <label for="whatNeedDetails" class="form__label uk-hidden"
              >Podaj inne</label
            >
            <input
              class="form-input uk-width-1-1"
              id="whatNeedDetails"
              type="text"
              name="whatNeedDetails"
              ref="otherInput"
              @input="event => delayTouchCounterComposition($v.form, 'whatNeedDetails', event.target.value)"
            />
            <span class="form__error-message form__error-message--no-label">
              <template v-if="!$v.form.whatNeedDetails.minLength">
                {{ validationMessage.minLength }}</template
              >
              <template v-if="!$v.form.whatNeedDetails.required">
                {{ validationMessage.required }}</template
              >
            </span>
          </div>
        </transition>
      </div>
    </template>
  </BriefStep>
</template>
<script>
import { minLength, required } from 'vuelidate/lib/validators';
import stepValidation from '../../mixins/stepValidation';

import BriefStep from '../global/BriefStep.vue';

export default {
  name: 'WhatYouNeed',
  components: { BriefStep },
  mixins: [stepValidation],
  data: () => ({
    title:
      'Skoro już co nieco o sobie wiemy, pora przejść do konkretów. Czego potrzebujesz?',
    form: {
      whatNeed: [],
      whatNeedDetails: '',
    },
    hasDescription: false,
    formRadios: [
      {
        name: 'wyn-shop',
        value: 'sklep internetowy',
        label: 'sklep internetowy',
      },
      {
        name: 'wyn-website',
        value: 'strona firmowa',
        label: 'strona firmowa',
      },
      {
        name: 'wyn-landing-page',
        value: 'landing page',
        label: 'landing page',
      },
      {
        name: 'wyn-blog',
        value: 'blog',
        label: 'blog',
      },
      {
        name: 'dedicated-system',
        value: 'system dedykowany',
        label: 'system dedykowany',
      },
    ],
  }),
  validations() {
    if (!this.hasDescription) {
      return {
        form: {
          whatNeed: {
            required,
          },
        },
      };
    }
    return {
      form: {
        whatNeed: {
          required,
        },
        whatNeedDetails: {
          required,
          minLength: minLength(3),
        },
      },
    };
  },
  methods: {
    otherHandler() {
      this.hasDescription = !this.hasDescription;

      if (!this.hasDescription) {
        this.form.whatNeedDetails = '';
      } else {
        setTimeout(() => {
          this.$refs.otherInput.focus();
        }, 100);
      }
    },
  },
};
</script>
